import { useQuery } from '@tanstack/react-query';
import type { CardType, ChargeState, WorklistKind, WorklistResponse, WorklistState } from '@taksikortti/shared';
import { api } from './client';

export interface WorklistParams {
  cardType?: CardType[];
  kind?: 'all' | WorklistKind;
  showDone?: boolean;
  q?: string;
  state?: WorklistState[];
  invoiceState?: ChargeState[];
  paymentState?: ChargeState[];
  sortKey?: 'cardType' | 'korttinumero' | 'asiakas' | 'charges' | 'state' | 'invoiceState' | 'paymentState' | 'createdAt' | 'firstAt' | 'lastAt';
  sortDir?: 'asc' | 'desc';
  page?: number;
  pageSize?: number;
}

function toQuery(p: WorklistParams): string {
  const u = new URLSearchParams();
  for (const ct of p.cardType ?? []) u.append('cardType', ct);
  if (p.kind && p.kind !== 'all') u.set('kind', p.kind);
  if (p.showDone) u.set('showDone', 'true');
  if (p.q) u.set('q', p.q);
  for (const s of p.state ?? []) u.append('state', s);
  for (const s of p.invoiceState ?? []) u.append('invoiceState', s);
  for (const s of p.paymentState ?? []) u.append('paymentState', s);
  if (p.sortKey) u.set('sortKey', p.sortKey);
  if (p.sortDir) u.set('sortDir', p.sortDir);
  if (p.page != null) u.set('page', String(p.page));
  if (p.pageSize != null) u.set('pageSize', String(p.pageSize));
  const s = u.toString();
  return s ? `?${s}` : '';
}

export function useWorklist(params: WorklistParams) {
  return useQuery({
    queryKey: ['worklist', 'list', params],
    queryFn: () => api<WorklistResponse>(`/worklist${toQuery(params)}`),
    staleTime: 15_000,
  });
}
